export default __webpack_public_path__ + "static/testimonial__3-4ec7808b0ef8698201b686a9e29f83eb.jpg";